export function stickySharing() {
    let indent = (window.innerWidth < 1800 && window.innerWidth > 1200) ? 180 : 140;

    function sticky() {
        if (window.innerWidth >= 1200) {
            let content = document.querySelector('.has-share');
            let wrapPos = {};
            let fixedElements = content.querySelectorAll('.fixed-element');

            for (let i = 0; i < fixedElements.length; i++) {
                let fixedItem = fixedElements[i];
                if (content.contains(fixedItem)) {
                    let fixedItemSocial = fixedItem.querySelector('.social');
                    let fixedItemHeight = parseInt(getComputedStyle(fixedItemSocial, null).getPropertyValue('height'));
                    wrapPos = content.getBoundingClientRect();

                    if (wrapPos.top <= indent) {
                        fixedItem.classList.add('sticky');
                    } else {
                        fixedItem.classList.remove('sticky');
                    }
                    if (wrapPos.bottom <= fixedItemHeight + indent) {
                        fixedItem.classList.add('bottom-pos');
                    } else {
                        fixedItem.classList.remove('bottom-pos');
                    }
                }
            }
        }
    }

    window.addEventListener("resize", function () {
        sticky();
    });
    window.addEventListener("scroll", function () {
        sticky();
    });
    window.addEventListener("load", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickySharing.js